module.exports = __webpack_public_path__ + "img/sz-cinemathek.5af76319.jpg";